export const EnquiryFormFieldMapping = new Map<string, string>([
  ['businessABN', 'Business ABN'],
  ['businessName', 'Business name'],
])

export enum AwardStatuses {
  AwardSaved = 'Award Saved',
  AwardOpen = 'Award Open',
  AwardClosed = 'Award Closed',
  InProgress = 'In Progress',
  AwardClosedNotSubmitted = 'Award Closed - Not Submitted',
  AwardCancel = 'Award Cancelled',
  AwardRecommendedLinksProvided = 'Recommended links provided',
  AwardAdviceProvided = 'Advice Provided',
  AwardAssistanceCompleted = 'Assistance Completed',
  AwardResponseToRequestForInformationReceived = 'Response to Request for Information Received',
}

export const DefaultIndustry: IIndustry = {
  name: 'No industry found',
  awardCode: '',
  awardName: '',
}
export const DefaultOccupation: IOccupation = {
  name: 'No occupation found',
  industries: [],
}

export class IFindMyAwardRequest {
  search: string
  top: number
}

export class IIndustry {
  name: string
  awardCode: string
  awardName: string
}

export class IOccupation {
  name: string
  industries: IIndustry[]
}

// export class ISubIndustryResult {
//   awardCode: string
//   name: string
// }

export class ReferenceType {
  id: string
  name: string
}

export interface IFindMyAwardRecommendedLink {
  name: string
  url: string
  briefDescription: string
}

export interface IAwardRecommendedLink {
  name: string
  url: string
  briefDescription: string
}

export interface IAwardCoverageResponse {
  registeredAgreement: boolean
  recommendedLinks?: IAwardRecommendedLink[]
}

export interface IFindMyAwardPreLodgementResponse {
  id: string
  enquiryNumber: string
  enquiryStatus: string
  isOpen: boolean
  requestForInfoType?: ReferenceType
  requestForInfoSubTypes?: ReferenceType[]
  otherQuestions: string
  recommendedLinks?: IFindMyAwardRecommendedLink[]
}

export interface IAward {
  registeredAgreement: boolean
  awardCode: string
  awardName: string
  occupation: string
  industry: string
}

export class Award implements IAward {
  registeredAgreement = false
  awardCode = ''
  awardName = ''
  occupation = ''
  industry = ''

  constructor(init?: Award) {
    if (init) {
      ;(this.registeredAgreement = init.registeredAgreement),
        (this.awardCode = init.awardCode),
        (this.awardName = init.awardName),
        (this.occupation = init.occupation),
        (this.industry = init.industry)
    }
  }
}
